import React from 'react';
import { Question, Option } from '../../types/survey';
import { motion } from 'framer-motion';
interface RadioQuestionProps {
  question: Question;
  selectedOptionId?: string;
  onSelect: (questionId: string, optionId: string) => void;
}
export function RadioQuestion({
  question,
  selectedOptionId,
  onSelect
}: RadioQuestionProps) {
  return <div className="mb-8 last:mb-0" data-id="element-37">
      <h3 className="text-lg font-semibold text-slate-900 mb-4 leading-tight" data-id="element-38">
        {question.text}
        {question.required !== false && <span className="text-teal-600 ml-1" data-id="element-39">*</span>}
      </h3>

      <div className="space-y-3" data-id="element-40">
        {question.options.map(option => <label key={option.id} className={`
              relative flex items-center p-4 rounded-lg border-2 cursor-pointer transition-all duration-200
              ${selectedOptionId === option.id ? 'border-teal-600 bg-teal-50' : 'border-slate-200 hover:border-slate-300 hover:bg-slate-50'}
            `} data-id="element-41">
            <input type="radio" name={question.id} value={option.id} checked={selectedOptionId === option.id} onChange={() => onSelect(question.id, option.id)} className="sr-only" data-id="element-42" />

            <div className={`
              w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center flex-shrink-0 transition-colors
              ${selectedOptionId === option.id ? 'border-teal-600' : 'border-slate-400'}
            `} data-id="element-43">
              {selectedOptionId === option.id && <div className="w-2.5 h-2.5 rounded-full bg-teal-600" data-id="element-44" />}
            </div>

            <span className={`text-base ${selectedOptionId === option.id ? 'text-teal-900 font-medium' : 'text-slate-700'}`} data-id="element-45">
              {option.label}
            </span>
          </label>)}
      </div>
    </div>;
}